import { type ChatMediaType } from 'cpool-constants';
import { useTranslation } from 'react-i18next';

import { FileRow } from './FileRow';
import { PanelSection } from './PanelSection';
import { DEFAULT_MESSAGE_PAGE_SIZE } from '~/features/whatsapp/constants';
import { useChatMessages } from '~/features/whatsapp/hooks/useChatMessages';

type Props = {
    chatId: string;
};

// Client-side filter over `useChatMessages` — reuses the same cache ChatView populates.
export const FilesSection = ({ chatId }: Props) => {
    const { t } = useTranslation();
    const { messages } = useChatMessages(chatId, DEFAULT_MESSAGE_PAGE_SIZE);

    const files = messages.filter(
        (message): message is typeof message & { mediaKey: string; mediaType: ChatMediaType } =>
            Boolean(message.mediaKey) && Boolean(message.mediaType),
    );

    return (
        <PanelSection title={t('WHATSAPP_CHAT.USER_INFO.FILES.TITLE', { count: files.length })}>
            <div className="flex flex-col gap-2 py-2">
                {files.length === 0 && <p className="text-sm text-grey">{t('WHATSAPP_CHAT.USER_INFO.FILES.EMPTY')}</p>}
                {files.map((file) => (
                    <FileRow
                        key={file.messageId}
                        chatId={chatId}
                        mediaFileName={file.mediaFileName}
                        mediaKey={file.mediaKey}
                        mediaType={file.mediaType}
                        name={file.content ?? file.mediaKey}
                    />
                ))}
            </div>
        </PanelSection>
    );
};
